<template>
    <div>
        <div class="mt-5 text-center">
            กำลัง Login Line
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import CacheHelper from '../../../helper/CacheHelper.js';
import LineFunction from '@/helper/facade/LineFunction.js';
import BzbsAuth from '@/service/BzbsAuth.js';

export default {
    name: 'LoginLine',
    data: function() {
        return {
            liffId: null,
        };
    },
    created: function() {
        this.initLiff();
    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();
            lineFunction.init(this.liffId).then(() => {
                var currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = lineFunction.getIdToken();
                    if (idToken != null) {

                        this.saveCacheLineIdToken(idToken);
                        this.loginBzbs(idToken);
                    } else {

                        this.$router.replace('/error');
                    }
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {

                alert('catch');
                console.log(err);
                this.$router.replace('/error');
            });
        },
        loginBzbs: async function(idToken) {
            Account.removeCacheUser();
            var user = await this.apiLoginLine(idToken);
            if (user != null) {
                // user.userLevel <= 0
                this.redirectLogin();
            }
        },
        apiLoginLine: async function(idToken) {
            return new Promise((resolve) => {
            // var userLevel = 0;
                BzbsAuth.apiLoginLine(idToken).then((res) => {
                    //userLevel = res.data.userLevel;
                    Account.setLogin(res.data);
                    resolve(res.data);
                    //return Account.apiGetProfile();
                }).catch((err) => {
                    // TODO remove this debug
                    console.log(err);
                    // alert(err.response.data);
                    this.redirectNotLogin();
                });
            })
        },

        apiGetProfile: async function() {
            return new Promise((resolve, reject) => {
                Account.apiGetProfile().then(() => {
                    resolve();
                }).catch((err) => {
                    // this.$router.push('/register');
                    window.location.replace('/register');
                    reject(err);
                });
            })
        },
        redirectNotLogin: function() {
            let targetPage = this.$route.query.target_page;
            if (targetPage && targetPage.indexOf('getfriend') > -1) {
                //% /register/getfrined/{refcode}
                window.location.replace('/' + targetPage);
            } else {
                let cache = new CacheHelper('cookie');
                var diorid =  cache.getCache('DiorQrCustomerId');
                if (diorid) {
                    window.location.replace("/register?qr=true");
                } else {
                    switch (targetPage)
                    {
                        case "scanqr":
                            window.location.replace("/register?qr=true");
                            break;
                        case "register":
                            window.location.replace("/register");
                            break;
                        case "home":
                            window.location.replace("/");
                            break;
                        default:
                            window.location.replace("/");
                            break;
                    }
                }


            }
        },
        redirectLogin: function() {
            var targetPage = this.$route.query.target_page;
            if (targetPage != null) {
                window.location.replace('/' + targetPage);
            } else {
                window.location.replace('/');
            }
        },
        saveCacheLineIdToken: function(lineIdToken) {
            let cache = new CacheHelper('session');
            cache.setCache('line_id_token', { token: lineIdToken });
        },
    },
}
</script>
